import storage from 'localforage';
import _fromPairs from 'lodash/fromPairs';
import * as c from '../constants/preferences';
import { VALID_UNITY_MODES } from '../constants/unity';
import {
  VERTICAL,
  HORIZONTAL,
  PANE_QUIZ_SIZE_DEFAULT,
  PANE_WORKSHEET_SIZE_DEFAULT,
} from '../constants/common';

const sanitizePreference = (pref, value) => {
  switch (pref) {
    case c.AUTO_SAVE:
      return value !== false;
    case c.DOCK_POSITION:
      return value === 'right' ? 'right' : 'left';
    case c.UNITY_MODE:
      return VALID_UNITY_MODES.indexOf(value) > -1
        ? value
        : VALID_UNITY_MODES[0];
    case c.PANE_QUIZ_ORIENTATION:
      return value === HORIZONTAL ? HORIZONTAL : VERTICAL;
    case c.PANE_WORKSHEET_ORIENTATION:
      return value === VERTICAL ? VERTICAL : HORIZONTAL;
    case c.PANE_QUIZ_SIZE:
      if (!value || typeof value !== 'number') {
        return PANE_QUIZ_SIZE_DEFAULT;
      }
    case c.PANE_WORKSHEET_SIZE:
      if (!value || typeof value !== 'number') {
        return PANE_WORKSHEET_SIZE_DEFAULT;
      }
    default:
      return value;
  }
};

export const setPreference = (preference, value) => ({
  type: c.SET_PREFERENCE,
  preference,
  value: sanitizePreference(preference, value),
});

export const savePreference = (preference, value) => {
  if (c.VALID_PREFERENCES.indexOf(preference) > -1) {
    const action = setPreference(preference, value);
    storage
      .setItem(preference, action.value)
      .catch((err) =>
        console.warn(
          `Error saving preference ${preference} with value ${value}: ${err.message}`
        )
      );
    return action;
  } else {
    return {
      type: '__NO_OP',
    };
  }
};

export const resetPreferences = () => ({
  type: c.RESET_PREFERENCES,
});

export const clearPreferences = () => {
  if (storage) {
    c.VALID_PREFERENCES.forEach((key) => storage.removeItem(key));
  }
  return resetPreferences();
};

export const loadSavedPreferences = () => (dispatch) => {
  return Promise.all(
    c.VALID_PREFERENCES.map((pref) => {
      return storage
        .getItem(pref)
        .then((raw) => [pref, sanitizePreference(pref, raw)])
        .catch((err) => []);
    }, Promise.resolve())
  )
    .then((asArray) => _fromPairs(asArray))
    .then((prefs) => {
      dispatch({
        type: c.LOAD_PREFERENCES,
        preferences: prefs,
      });
    })
    .catch((err) => {
      console.warn('Error loading preferences', err.message);
    });
};
